export function dxGridUserSettings(instance) {
    if (!instance) {
        throw new Error('function dxGridUserSettings(instance) arg instance error');
    }
    const state = instance.state();
    const settings = { columns: [] };
    if (state.columns === undefined) {
        return settings;
    }
    // for (const column of state.columns) {
    //     const settingsColumn = {
    //         name: column.name,
    //         dataType: column.dataType,
    //         dataField: column.dataField,
    //         visibleIndex: column.visibleIndex,
    //         width: column.width,
    //         visible: column.visible,
    //     };
    //     settings.columns.push(settingsColumn);
    // }
    return state;
}

/*
{
    "searchText": "",
    "filterValue": null,
    "columns": [
        {
            "visibleIndex": 0,
            "dataField": "kod_sulst",
            "name": "kod_sulst",
            "dataType": "string",
            "width": 150,
            "visible": false
        },
        {
            "visibleIndex": 1,
            "dataField": "sulst",
            "name": "sulst",
            "dataType": "string",
            "width": 360,
            "visible": true,
            "sortOrder": "desc",
            "sortIndex": 0
        },
        {
            "visibleIndex": 2,
            "dataField": "type_sulst",
            "name": "type_sulst",
            "dataType": "string",
            "width": 150,
            "visible": true
        },
        {
            "visibleIndex": 3,
            "dataField": "name_sulst",
            "name": "name_sulst",
            "dataType": "string",
            "width": 1099.34375,
            "visible": true
        },
        {
            "visibleIndex": 4,
            "dataField": "pr_active",
            "name": "pr_active",
            "dataType": "boolean",
            "width": 150,
            "visible": true
        }
    ],
    "preferencesState": true
}
*/
